// ╔══════════════════════════════════════════════════════════════╗
// ║ host i18n 字典 —— atomic key 池子,DB 通过 *Key/*Keys 字段引用    ║
// ║ 本文件由 scripts/write_locales_with_comments.mjs 生成           ║
// ║                                                                ║
// ║ 命名空间结构:                                                   ║
// ║   1. shared 网站 UI(exit/modal/.../common)                    ║
// ║   2. 跨游戏共用桶(paytable/rules/history/historyDetail)       ║
// ║   3. 游戏独占(bskg/fhcq/mjhl/mjhl2/sjcz/sjddj/sjnw/wldd/xltb/xltb2) ║
// ║                                                                ║
// ║ key 编号约定(在同一对象内):                                     ║
// ║   title*       段/页标题                                        ║
// ║   subtitle*    段副标题                                         ║
// ║   rule*        规则条目                                         ║
// ║   label*       字段标签(historyDetail 常用)                    ║
// ║   formula*     公式示例(paytable winRule 用)                  ║
// ║   symbolName*  符号名(百搭/夺宝)                              ║
// ║ 数字升序连续 1..N,删除某条后用 cleanup_and_renumber.mjs 重排    ║
// ║                                                                ║
// ║ 维护流程:                                                       ║
// ║   - 改文案 → 直接编辑此文件,push 后刷新 iframe 立刻生效         ║
// ║   - 加 key → 在合适命名空间下新增,然后 admin 后台填 *Key 引用   ║
// ║   - 删 key → DB 先去掉引用,再 cleanup_and_renumber.mjs 一键清理 ║
// ╚══════════════════════════════════════════════════════════════╝

export default {
  // ┌──────────────────────────────────────────────────────────────┐
  // │ shared 网站自身 UI 文案(host 弹窗、错误提示、加载态等)         │
  // └──────────────────────────────────────────────────────────────┘

  // 游戏退出确认弹窗
  exit: {
    title: '游戏已经安全退出',
    button: '回到游戏',
    desc: '可以点击下方按钮回到游戏。',
  },

  // 通用 modal 文案
  modal: {
    loading: '正在加载',
  },

  // 网络重试 toast
  retry: {
    toast: '网络繁忙，正在重试... (第{count}次)',
  },

  // 竖屏提示
  orientation: {
    title: '请切换到竖屏模式',
    subtitle: '继续游戏',
  },

  // 余额弹窗
  balance: {
    title: '余额',
    retry: '重试',
    walletLabel: '现金钱包',
  },

  // 通用错误提示(common.errors.*)
  common: {
    errors: {
      fetchFailed: '获取余额失败，请重试',
      missingLogin: '缺少登录信息',
      networkError: '网络错误',
      tokenExpired: '登录已失效',
    },
  },

  // ┌──────────────────────────────────────────────────────────────┐
  // │ 跨游戏共用内容(≥2 个游戏引用)                                 │
  // │   编号规则:title* / subtitle* / rule* / label* / formula* / symbolName*  │
  // └──────────────────────────────────────────────────────────────┘

  // 赔付表段标题、规则文本、符号名、公式示例
  paytable: {
    title: '赔付表',
    title1: '中奖线',
    title2: '最高赢奖倍数',
    title3: '免费旋转模式',
    title4: '奖金倍数轴',
    title5: '符号赔付值',
    label1: '参考以上例子:',
    label2: '本例中的总赢奖:',
    formula1: '2 x 3 x 2 x 1 = 12',
    formula2: '30 x 12 = 360',
    symbolName1: '夺宝符号',
    symbolName2: '百搭符号',
    rule1: '中奖路奖金按照从最左至右卷轴的顺序派发。',
    rule2:
      '中奖路的奖金计算方式是按照从卷轴的最左边到最右边，每个赢奖符号相邻的数目乘以该符号的中奖路数目。',
    rule3: '赢奖符号的赔付是由该符号的赔付值乘以中奖路的数目所得。',
    rule4:
      '每轮游戏结束并发放奖金后，所有赢奖符号都将爆炸消除，让其上方的符号向下跌落以进行新一轮的旋转。',
    rule5: '额外的中奖组合都将计入每次旋转的赢奖中，直到没有其他中奖组合。',
    rule6: '所有赢奖以现金显示。',
    rule7: '若主游戏或免费旋转模式的总赢奖达到投注金额的5,000倍，则旋转结束。',
    rule8: '最高赢奖金额为投注金额的5,000倍。',
    rule9: '免费旋转可以被重复触发。',
    rule10:
      '当3个夺宝符号出现在卷轴的任意位置时，免费旋转模式将被触发并获得10次免费旋转。每个额外的夺宝符号都将触发多2次的免费旋转。',
    rule11:
      '赢奖支付后，总奖金倍数将保持不变，直到下一次免费旋转出现赢奖时，与该免费旋转的总奖金倍数相加。',
    rule12:
      '当3个夺宝符号出现在卷轴的任意位置时，免费旋转模式将被触发并获得12次免费旋转。每个额外的夺宝符号都将触发多2次的免费旋转。',
    rule13: '免费旋转模式期间，卷轴上方的乘数将分别增加至x3、x6、x9和x15。',
    rule14: '免费旋转模式开始时，奖金倍数为x8。',
    rule15:
      '若在任何免费旋转期间，卷轴上出现一个或多个赢奖符号，在奖金被支付并且新符号跌落之后，奖金倍数将翻一倍。',
    rule16: '在任何旋转期间，所有赢奖都将乘以卷轴上方所显示的乘数值，第一轮旋转以x1开始。',
    rule17: '第一轮旋转中的任何赢奖都会使第二轮旋转的乘数递增到x2。',
    rule18: '第二轮旋转中的任何赢奖都会使第三轮旋转的乘数递增到x3。',
    rule19: '第三轮旋转中的任何赢奖都会使第四轮旋转（及以后）的乘数递增到x5。',
    rule20: '任何主游戏旋转开始时，奖金倍数为x1。',
    rule21: '百搭符号可替代除夺宝符号外的所有符号。',
    rule22: '中奖组合将依照每个符号在赔付表上的派彩赢得相应彩金。',
    rule23: '百搭符号只出现在第2，第3和第4转轴上。',
    rule24:
      '在任何旋转期间，第3和/或第4卷轴上的某些符号（不包括百搭符号和夺宝符号）将可能显示为金框符号。',
    rule25: '在新符号跌落后的每一轮旋转中，上一轮赢奖中所涉及的金框符号将被转换为百搭符号。',
    title6: '1,024路',
    title7: '金色麻将符号',
    title8: '金框符号',
    title9: '赢奖符号收集仪',
  },

  // 规则页段标题、规则文本、mainGame 操作说明、additionalInfo 附加信息(跨游戏共享)
  rules: {
    title: '游戏规则',
    rule1: '不同中奖路上的奖金会被叠加。',
    rule2: '免费旋转模式中投注大小和投注倍数和触发免费旋转模式时的参数保持一致。',
    rule3: '投注大小可以在"投注大小"选项中设定。',
    rule4: '投注倍数可以在"投注倍数"选项中设定。',
    rule5: '投注总额可以在"投注总额"选项中设定。',
    rule6: '"现金钱包"用来显示下注者可用的现金余额。',
    rule7: '"自动旋转"可以根据玩家所选择的回合数量自动进行游戏。',
    rule8: '中奖组合和奖金派发是根据"赔付表"进行的。',
    rule9: '一条中奖路所得的奖励等同于显示在"赔付表"上的符号赔付值乘以投注大小和投注倍数。',
    rule10: '中奖线奖金按照从最左至右卷轴的顺序派发。',
    rule11:
      '中奖路的奖金计算方式是按照从卷轴的最左边到最右边每个赢奖符号相邻的数目乘以该符号的中奖路数目。',
    rule12:
      '游戏共有1,024个中奖路(固定)并规定了20条基础投注，1到10的投注倍数和0.03到0.90的投注大小。',
    rule13: '游戏规定了20条固定中奖线，1到10的投注倍数和 0.03 到 0.90 的投注大小。',
    rule14: '只支付每条中奖线中赢取最高的奖金。',
    additionalInfo: {
      title: '附加信息',
      content: {
        '0': '如遇任何机械故障，所有游戏及奖金(派彩)一律作废。',
        '1': '任何因游戏结果所产生的争议，均以游戏历史页面中所显示的记录为最终依据。',
      },
    },
    bonusMultiplier: '奖金翻倍',
    mainGame: {
      title: '主游戏',
      items: {
        autoSpin: {
          title: '自动旋转',
          descriptions: {
            '0': '自动旋转可以根据选的次数进行自动游戏。',
            '1': '点击数值以选择自动旋转的次数。',
          },
        },
        bet: {
          title: '投注金额',
          descriptions: {
            '0': '点击显示投注选项。',
            '1': '投注大小:拖动以选择投注大小。',
            '2': '投注倍数:拖动以选择投注倍数。',
            '3': '投注总额:拖动以选择投注金额。',
            '4': '最大投注:点击按钮可以把投注大小、投注倍数的数值调到最大。',
          },
        },
        close: {
          title: '关闭',
          descriptions: '点击回到主游戏。',
        },
        history: {
          title: '历史',
          descriptions: {
            '0': '显示游戏历史记录详情。下滑到页面底部可加载更多记录。',
            '1': '点击({dateIcon})选择日期范围，显示相应的历史记录。',
          },
        },
        minus: {
          title: '减少',
          descriptions: '点击减少投注金额。',
        },
        paytable: {
          title: '赔付表',
          descriptions: '显示中奖组合以及赔付表。',
        },
        plus: {
          title: '增加',
          descriptions: '点击增加投注金额。',
        },
        rules: {
          title: '规则',
          descriptions: '显示游戏规则和按键功能。',
        },
        settings: {
          title: '更多设置',
          descriptions: '点击访问其他设置。',
        },
        sound: {
          title: '声音',
          descriptions: '点击打开或关闭游戏声音。',
        },
        spin: {
          title: '旋转按钮',
          descriptions: {
            '0': '单击后可在当前基础投注、投注大小和投注倍数下开始游戏。',
            '1': '旋转过程中单击按钮或游戏区可以马上停止当前旋转。',
            '2': '仅适用于桌面版',
            '3': '按下空格键，使用当前的基础投注、投注大小和投注倍数进行旋转。',
            '4': '按住空格键，将持续进行旋转，直到松开空格键。',
            '5': '当卷轴旋转时，按下空格键即可跳过旋转动画，直接查看结果（视网络连接稳定性而定）。',
            '6': '当屏幕上仅显示一个可用按钮时，按下空格键即可激活它。',
          },
        },
        stop: {
          title: '停止按钮',
          descriptions: '单击按钮停止旋转。在自动游戏模式，剩余旋转次数会显示在按钮中。',
        },
        turbo: {
          title: '极速旋转',
          descriptions: '点击启动或停止极速旋转，启动极速旋转将减少主游戏中卷轴旋转的持续时间。',
        },
        wallet: {
          title: '钱包余额',
          descriptions: '点击显示拥有钱包的余额。',
        },
        win: {
          title: '赢奖金额',
          descriptions: '点击显示游戏历史。',
        },
      },
    },
    rule15: '不同中奖线上的奖金会被叠加。',
    rule16: '中奖组合所赢得的奖励相等于“赔付表”上所显示的数额乘以投注大小、以及投注倍数。',
    rule17: '金色麻将符号只出现在第2、第3、和第4转轴上。',
  },

  // 历史页 UI 文案(列名、过滤标签、状态提示)
  history: {
    title: '历史记录',
    columns: {
      bet: '投注',
      orderId: '交易单号',
      time: '时间',
      win: '盈利',
    },
    errors: {
      configLoadFailed: '配置加载失败',
      fetchDataFailed: '获取数据失败',
    },
    filterLabels: {
      confirm: '确定',
      custom: '自定',
      endDate: '结束',
      last7days: '最近 7 天',
      selectRange: '选择日期范围',
      startDate: '开始',
      today: '今天',
    },
    statsLabels: {
      records: '条记录',
    },
    statusLabels: {
      error: '加载失败',
      loading: '加载中...',
      noData: '没有历史记录',
      noMoreData: '已加载全部记录',
      retry: '点击重试',
    },
  },

  // 历史详情页字段标签(由 game_history_detail_config.config.labelKeys 引用)
  historyDetail: {
    label1: '无中奖组合',
    label2: '回合',
    label3: '投注大小 x 投注倍数 x 符号赔付值',
    label4: '三星连珠',
    label5: '四星连珠',
    label6: '五星连珠',
    label7: '六星连珠',
    label8: '七星连珠',
    label9: '八星连珠',
    label10: '投注倍数',
    label11: '七星连珠',
    label12: '八星连珠',
    label13: '普通旋转',
    label14: '免费旋转: {index}/{total}',
    label15: '投注大小 x 投注倍数 x 符号赔付值 x 中奖路 x 奖金倍数',
    label16: '{count}连珠',
    label17: '第{n}回合',
    balance: '余额',
    bet: '投注',
    betSize: '投注大小',
    bonusMultiplier: '奖金乘数',
    close: '关闭',
    freeSpins: '次免费旋转',
    goldenPrefix: '金',
    multiplier: '乘数',
    symbol: '符号',
    totalWin: '总赢奖',
    transaction: '交易单号',
    win: '盈利',
    winInfo: '赢奖情况',
    winWays: '条中奖路',
  },

  // ┌──────────────────────────────────────────────────────────────┐
  // │ 游戏独占文案(每个游戏自己的 paytable / rules 子命名空间)        │
  // │   仅被该游戏(或同系列游戏:xltb/xltb2、mjhl/mjhl2)引用          │
  // └──────────────────────────────────────────────────────────────┘

  // 宝石矿工(Gemstones Gold)
  bskg: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1: '最高赢奖金额为投注金额的7,500倍。',
      rule2: '若主游戏或免费旋转模式的总赢奖达到投注金额的7,500倍，则旋转结束。',
      rule3:
        '每次免费旋转开始时，6个倍数值为x2至x500的奖金翻倍符号将出现在奖金倍数轴的任意位置上，并且每个符号由2根木条封住。',
      rule4: '免费旋转模式期间，2个夺宝符号出现在卷轴上的任意位置时，将奖励多5次免费旋转。',
      rule5:
        '每次旋转开始时，3个倍数值为x2至x500的奖金翻倍符号将出现在奖金倍数轴的任意位置上，并且每个符号由3根木条封住。',
      rule6:
        '在每一回合中，如果任何奖金翻倍符号上方有1个或多个赢奖符号，则将移除该奖金翻倍符号的一根木条。',
      rule7: '当奖金翻倍符号的3根木条都被移除后，该符号将完全显示出来。',
      rule8:
        '当旋转结束时，所有已揭示的奖金翻倍符号的倍数值将相加，并且该旋转的总赢奖将乘于该总奖金倍数。',
      rule9: '每次旋转，任意8个或更多相同符号出现在卷轴上任意位置即可形成中奖组合。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '宝石矿工',
      rule1: '宝石矿工是一款5x6的符号消除类老虎机游戏，编入了奖金倍数轴，以及高达x500的奖金倍数。',
      rule2: '游戏规定了投注20 条基础投注（固定）， 1到10的投注倍数和0.03到0.90的投注大小。',
    },
    // ── 历史详情专属文案 ──
    historyDetail: {
      // 结算回合标签:bskg render 直接 t() 读,不走 DB labelKeys
      settlementMultiplier: '奖金倍数',
      settlementBonus: '倍数奖金',
      // 赢奖情况公式 label(bskg 仅 投注大小 x 投注倍数 x 符号赔付值;无中奖路/奖金倍数)
      formulaLabel: '投注大小 x 投注倍数 x 符号赔付值',
    },
  },

  // 凤凰传奇(Phoenix Rises)
  fhcq: {
    // ── 赔付表专属文案 ──
    paytable: {
      title1: '243 路',
      symbolName1: '免费旋转符号',
      rule1:
        '当5、6或7个免费旋转符号出现在卷轴的任意位置时，将触发免费旋转模式并获得12次免费旋转。',
      rule2:
        '如果游戏由5个免费旋转符号所触发，则免费旋转的奖金倍数将从x1开始，并且每次免费旋转后，奖金倍数将增加1。',
      rule3:
        '如果游戏由6个免费旋转符号所触发，则免费旋转的奖金倍数将从x2开始，并且每次免费旋转后，奖金倍数将增加2。',
      rule4:
        '如果游戏由7个免费旋转符号所触发，则免费旋转的奖金倍数将从x3开始，并且每次免费旋转后，奖金倍数将增加3。',
      rule5: '可实现的最大倍数值为x150。',
      rule6: '免费旋转期间，当5个免费旋转符号出现在卷轴的任意位置时，将奖励12次免费旋转。',
      rule7: '百搭符号只出现在第2，第3，和第4卷轴上。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '凤凰传奇',
      rule1: '凤凰传奇是一个5轴3行的视频老虎机游戏，编入了免费旋转模式和高达x150的奖金倍数。',
      rule2:
        '游戏共有243个中奖路（固定）并规定了 20 条基础投注，1到10的投注倍数和0.03到0.90的投注大小。',
    },
    // ── 历史详情专属文案 ──
    historyDetail: {
      // 普通旋转赢奖公式 label(无奖金倍数;免费旋转走 DB labelKeys.formulaLabel_freeSpin)
      formulaLabel: '投注大小 x 投注倍数 x 符号赔付值 x 中奖路',
    },
  },

  // 麻将胡了(Mahjong Ways)
  mjhl: {
    // ── 赔付表专属文案 ──
    paytable: {
      formula1: '1 x 3 x 2 = 6',
      formula2: '10 x 6 = 60',
      rule1:
        '在任何旋转期间，第2、第3和/或第4上的某些符号（不包括百搭符号和夺宝符号）将可能显示为金色。',
      rule2: '在新符号跌落后的每一轮旋转中，上一轮赢奖中所涉及的金色麻将符号将被转换为百搭符号。',
      rule3: '免费旋转模式期间，卷轴上方的乘数将分别增加至x2、x4、x6和x10。',
    },
    // ── 规则页专属文案 ──
    rules: {
      title: '麻将胡了',
      rule1: '麻将胡了是一个5轴4行的视频老虎机游戏，编入了转换百搭符号以及奖金乘数递增的免费旋转。',
    },
  },

  // 麻将胡了2(Mahjong Ways 2,阿努比斯主题)
  mjhl2: {
    // ── 赔付表专属文案 ──
    paytable: {
      title1: '2,000 路',
      rule1: '免费旋转模式期间，第3列转轴上的所有符号（不包括百搭符号和夺宝符号）将显示为金色。',
      rule2: '卷轴上方的乘数将分别增加至x2、x4、x6和x10。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '麻将胡了2',
      rule1:
        '麻将胡了2是一个5轴4行（第2、第3及第4列转轴有额外的一行）的视频老虎机游戏，编入了转换百搭符号以及奖金乘数递增的免费旋转。',
      rule2:
        '游戏共有2,000个中奖路（固定）并规定了20条基础投注，1到10的投注倍数和0.03到0.90的投注大小。',
    },
  },

  // 赏金船长(Captain's Bounty)
  sjcz: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1:
        '当3个夺宝符号出现在卷轴的任意位置时，免费旋转模式将被触发并获得10次免费旋转。每个额外的夺宝符号都将触发多5次的免费旋转。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '赏金船长',
      rule1: '赏金船长是一个5轴3行的视频老虎机游戏，编入了具有消除功能的符号以及递增的奖金乘数。',
    },
  },

  // 赏金大对决(Wild Bounty Showdown)
  sjddj: {
    // ── 赔付表专属文案 ──
    paytable: {
      title1: '3600路',
      formula1: '2 x 2 x 2 = 8',
      formula2: '10 x 8 = 80',
      rule1:
        '若在任何旋转期间，卷轴上出现一个或多个赢奖符号，在奖金被支付并且新符号跌落之后，奖金倍数将翻一倍。',
      rule2: '最高奖金倍数为x1,024。',
      rule3: '金框符号只出现在第3和第4转轴上。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '赏金大对决',
      rule1:
        '赏金大对决是一个6轴（3行于卷轴1和6，4行于卷轴2和5，5行于卷轴3和4）的视频老虎机游戏，编入了金框符号以及递增式奖金倍数。',
      rule2:
        '游戏共有3,600个中奖路（固定）并规定了20条基础投注，1到10的投注倍数和0.03到0.90的投注大小。',
      rule3: '金框符号只出现在第3和第4卷轴上。',
    },
  },

  // 赏金女王(Queen Of Bounty)
  sjnw: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1:
        '玩家可以选择任一项以开始免费旋转功能：20次免费旋转（x1/x2/x3/x5奖金倍数）、10次免费旋转（x3/x6/x9/x20奖金倍数）或5次免费旋转（x6/x12/x18/x40奖金倍数）。',
      rule2: '在任何旋转期间，所有赢奖都将乘以转轴上方所显示的倍数值，第一轮旋转以x1开始。',
      rule3: '第一轮旋转中的任何赢奖都会使第二轮旋转的倍数递增到x2。',
      rule4: '第二轮旋转中的任何赢奖都会使第三轮旋转的倍数递增到x3。',
      rule5: '第三轮旋转中的任何赢奖都会使第四轮旋转（及以后）的倍数递增到x5。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '赏金女王',
      rule1: '当3个或更多夺宝符号出现在卷轴的任意位置时，免费旋转模式将被触发。',
      rule2:
        '如果免费旋转由3个或更多的夺宝符号所触发，则每个额外的夺宝符号将在20次免费旋转选项中附加4次免费旋转；10次免费旋转选项中附加2次免费旋转；和5次免费旋转选项中附加1次免费旋转。',
      rule3: '点击任一选项以指定的免费旋转次数和奖金倍数开始免费旋转。',
      rule4:
        '赏金女王是一个5轴3行的视频老虎机游戏，编入了具有消除功能的符号、递增式奖金倍数以及不同的免费旋转选项。',
    },
  },

  // 亡灵大盗(Wild Bandito)
  wldd: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1:
        '若在任何免费旋转期间，卷轴上出现一个或多个赢奖符号，在奖金被支付并且新符号跌落之后，奖金倍数将增加1。',
      rule2:
        '若在任何旋转期间，卷轴上出现一个或多个赢奖符号，在奖金被支付并且新符号跌落之后，奖金倍数将增加1。',
      rule3: '金框符号只出现在第2，第3，和第4卷轴上。',
      rule4:
        '在任何旋转期间，第2、第3和/或第4卷轴上的某些符号（不包括百搭符号和夺宝符号）将可能显示为金框符号。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '亡灵大盗',
      rule1:
        '免费旋转模式期间，第3列卷轴上的所有符号（不包括百搭符号和夺宝符号）将显示为金框符号。',
      rule2: '免费旋转模式开始时，奖金倍数为x1。',
      rule3: '亡灵大盗是一个5轴4行的视频老虎机游戏，编入了金框符号以及奖金倍数递增的免费旋转。',
    },
  },

  // 寻龙探宝(Dragon Hatch)
  xltb: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1: '水平或竖直上任意4个或更多相连符号即可形成中奖组合。',
      rule2:
        '每轮游戏结束并发放奖金后，所有 赢奖符号都将爆炸消除，让其上方的符号向下跌落以进行新一轮的旋转。',
      rule3: '百搭符号可替代所有符号。',
      rule4: '在任何旋转期间，若收集了50个或更多的赢奖符号，则该没有中奖组合的回合中触发火龙模式。',
      rule5:
        '火龙模式期间，随机选择的符号（百搭符号除外）将以棋盘格纹添加到卷轴中（它不会替换任何百搭符号）。',
      rule6: '在任何旋转期间，若收集了10个或更多的赢奖符号，则该没有中奖组合的回合中触发土龙模式。',
      rule7: '土龙模式期间，将所有低赔付符号从卷轴中移除。',
      rule8: '在任何旋转期间，若集满70个赢奖符号，则该没有中奖组合的回合中触发巨龙模式。',
      rule9: '巨龙模式期间，每个低赔付符号将转化为高赔付符号或百搭符号。',
      rule10:
        '在任何旋转期间，若收集了30个或更多的赢奖符号，则该没有中奖组合的回合中触发水龙模式。',
      rule11: '水龙模式期间，将在卷轴中添加4个百搭符号。',
      rule12: '在任何旋转期间，爆炸的赢奖符号将累积于卷轴上方的收集仪当中。',
      rule13: '赢奖符号收集到一定数量后，在没有中奖组合的回合中将触发一个模式。',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '寻龙探宝',
      rule1: '寻龙探宝是一款5x5的符号消除类老虎机游戏，该游戏编入了多种模式以实现更多赢奖机会。',
      rule2: '游戏规定了投注10 条基础投注（固定），1到10的投注倍数和0.03到0.90的投注大小。',
      rule3:
        '附加的百搭符号位置排列为：第二行的第二列、第四行的第二列、第二行的第四列和第四行的第四列。',
      rule4: '在任何旋转开始时，收集仪将重置为零。',
      rule5: '每次旋转中所收集的赢奖符号，上限为70。',
      rule6: '收集仪所触发的所有模式，在每次旋转中仅能触发一次。',
      rule7:
        '若有2个或更多的模式等待触发，则该没有中奖组合的回合中仅触发一个模式。下一个模式仅能在下一回没有中奖组合的情况下触发。这些模式将按照以下顺序触发：土龙模式、水龙模式、火龙模式、巨龙模式。',
      earthDragon: '土龙模式',
      fireDragon: '火龙模式',
      giantDragon: '巨龙模式',
      waterDragon: '水龙模式',
    },
  },

  // 寻龙探宝 2(Dragon Hatch 2)
  xltb2: {
    // ── 赔付表专属文案 ──
    paytable: {
      rule1: '最高赢奖金额为投注金额的10,000倍。',
      rule2: '若主游戏或免费旋转模式的总赢奖达到投注金额的10,000倍，则旋转结束。',
      rule3: '最高赢奖金额为投注金额的2,500倍。',
      rule4: '若主游戏或奖金游戏模式的总赢奖达到投注金额的2,500倍，则旋转结束。',
      rule5: '水平或竖直上任意4个或更多相连符号即可形成中奖组合。',
      rule6:
        '每轮游戏结束并发放奖金后，所有 赢奖符号都将爆炸消除，让其上方的符号向下跌落以进行新一轮的旋转。',
      rule7: '百搭符号可替代所有符号。',
      rule8: '中奖组合和奖金派发是根据“赔付表”进行的。',
      rule9:
        '在任何旋转期间，若收集了55个或更多的赢奖符号，则火龙模式将在没有中奖组合的回合中被触发。',
      rule10: '火龙模式期间，一个百搭符号将分别添加到卷轴1、2、4和5的随机位置上。',
      rule11: '土龙模式期间，将所有低赔付符号从卷轴中移除。',
      rule12:
        '在任何旋转期间，若收集了10个或更多的赢奖符号，则土龙模式将在没有中奖组合的回合中被触发。',
      rule13: '在任何旋转期间，若集满80个赢奖符号，则巨龙模式将在没有中奖组合的回合中被触发。',
      rule14:
        '巨龙模式开始时，卷轴上的四个角落都将分别添加一个百搭符号，并将保留在该位置上直到旋转结束为止。',
      rule15: '巨龙模式期间，所有低赔付符号将转换为高赔付符号。',
      rule16:
        '在任何旋转期间，若收集了30个或更多的赢奖符号，则水龙模式将在没有中奖组合的回合中被触发。',
      rule17:
        '水龙模式期间，一个随机选择的符号（土龙符号、水龙符号、火龙符号或龙睛符号）将垂直添加到卷轴的第二列，而另一个随机选择的符号（土龙符号、水龙符号、火龙符号或龙睛符号）将垂直添加到卷轴的第四列。',
      rule18: '在任何旋转期间，爆炸的赢奖符号将累积于卷轴上方的收集仪当中。',
      rule19: '赢奖符号收集到一定数量后，在没有中奖组合的回合中将触发一个模式。',
      rule20: '一个百搭符号位于卷轴的第三列第三行，并且每轮旋转都保留在该位置上。',
      title1: '粘性百搭符号',
    },
    // ── 规则页专属文案 ──
    rules: {
      subtitle1: '寻龙探宝2',
      rule1: '寻龙探宝2是一款5x5的符号消除类老虎机游戏，该游戏编入了多种模式以实现更多赢奖机会。',
      rule2: '游戏规定了投注10 条基础投注（固定），1到10的投注倍数和0.03到0.90的投注大小。',
      rule3: '在任何旋转开始时，收集仪将重置为零。',
      rule4: '收集仪所触发的所有模式，在每次旋转中仅能触发一次。',
      rule5: '每次旋转中所收集的赢奖符号，上限为80。',
      rule6:
        '若有2个或更多的模式等待触发，则该没有中奖组合的回合中仅触发一个模式。下一个模式仅能在下一回没有中奖组合的情况下触发。这些模式将按照以下顺序触发：土龙模式、水龙模式、火龙模式、巨龙模式。',
      earthDragon: '土龙模式',
      fireDragon: '火龙模式',
      giantDragon: '巨龙模式',
      waterDragon: '水龙模式',
    },
  },
}
